import { useQuery, useQueryClient } from "@tanstack/react-query";
import { axiosGet } from "@/services/axiosService";
import useStore from "@/pages/omni-builder/store";

export default function useWhatsAppConfig() {
  const queryClient = useQueryClient();
  const setIsWhatsappLoading = useStore((state) => state.setIsWhatsappLoading);
  return useQuery({
    queryKey: ["configurations", "whatsapp"],
    queryFn: async () => {
      const cachedData: any =
        queryClient.getQueryData(["configurations", "whatsapp"]) ?? null;

      if (!cachedData) {
        setIsWhatsappLoading(true);
      }
      const response = await axiosGet(
        "/configurations/getAppConfig?siteName=whatsapp",
      );
      let result: any = null;
      if (response.data) {
        const accounts = response.data.accounts ?? [response.data];
        result = {
          accounts: accounts.filter(Boolean),
          // Keep the first account fields for existing builder consumers.
          accessToken: accounts[0]?.accessToken,
          name: accounts[0]?.accountName,
          picture: accounts[0]?.picture,
          connections: accounts[0]?.connections,
          phoneNumbers: accounts.flatMap(
            (account: any) => account.phoneNumbers ?? [],
          ),
          id: accounts[0]?.id,
        };
      }

      // result contains accessToken, profile, phoneNumbers & wabaIds
      setIsWhatsappLoading(false);
      return result;
    },
    staleTime: Infinity,
  });
}
